import { TripContext } from 'contexts';
import React, { FC, Fragment, useContext } from 'react';
import { Stop, StopSummary } from 'services/types';
import './appointments-summary.scss';

type Props = {
    stop?: Stop,
    stopId?: number
}

export const AppointmentSummary: FC<Props> = ({ stopId, stop }) => {
    
    const tripContext = useContext(TripContext)
    const stopData: Stop = stop ?? tripContext.stops.find(s => s.id === stopId) ?? {} as Stop
    const summary: StopSummary = stopData.summary
    const na = '-'

    return (
        <Fragment>
            <div className="appointment-summary-row">
                <div className="appointment-summary-horizontal"></div>
                <div className="appointment-summary-horizontal">Lbs</div>
                <div className="appointment-summary-horizontal">Items</div>
                <div className="appointment-summary-horizontal">Piece</div>
            </div>
            <div className="appointment-summary-row">
                <div className="appointment-summary-heading">Dry</div>
                <div className="appointment-summary-content">{summary.dryWeight ?? na}</div>
                <div className="appointment-summary-content">{summary.dryLineItems ?? na}</div>
                <div className="appointment-summary-content">{summary.dryPieces ?? na}</div>
            </div>
            <div className="appointment-summary-row">
                <div className="appointment-summary-heading">Ref</div>
                <div className="appointment-summary-content">{summary.refrigeratedWeight ?? na}</div>
                <div className="appointment-summary-content">{summary.refrigeratedLineItems ?? na}</div>
                <div className="appointment-summary-content">{summary.refrigeratedPieces ?? na}</div>
            </div>
            <div className="appointment-summary-row">
                <div className="appointment-summary-heading">Frz</div>
                <div className="appointment-summary-content">{summary.frozenWeight ?? na}</div>
                <div className="appointment-summary-content">{summary.frozenLineItems ?? na}</div>
                <div className="appointment-summary-content">{summary.frozenPieces ?? na}</div>
            </div>
            <div className="appointment-summary-row">
                <div className="appointment-summary-heading highlight">Total</div>
                <div className="appointment-summary-content highlight"> {(summary.dryWeight + summary.refrigeratedWeight + summary.frozenWeight).toFixed(0) ?? na} </div>
                <div className="appointment-summary-content highlight"> {(summary.dryLineItems + summary.refrigeratedLineItems + summary.frozenLineItems).toFixed(0) ?? na} </div>
                <div className="appointment-summary-content highlight"> {(summary.dryPieces + summary.refrigeratedPieces + summary.frozenPieces).toFixed(0) ?? na} </div>
            </div>
        </Fragment>
    );
}